// funciones para determinar región
import * as FxLog from './FxLog';
import * as FxFetch from './FxFetch';
import { getStoreValue } from "../gx/GxStore";

export const isSpain = () => { return Boolean(getStoreValue('StoreSession', 'txIdi').startsWith('es.') || getStoreValue('StoreSession', 'txIdi').startsWith('xx.') ) }

export const isUsAu = () => { return Boolean(getStoreValue('StoreSession', 'txIdi').startsWith('us.') || getStoreValue('StoreSession', 'txIdi').startsWith('au.') ) }

export const isAndalusia = () => { return Boolean(
  isSpain() && (
    getStoreValue('StoreSession', 'txState').toLowerCase()==='almería' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='cádiz' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='córdoba' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='granada' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='huelva' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='jaén' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='málaga' || 
    getStoreValue('StoreSession', 'txState').toLowerCase()==='sevilla' 
  )
) }

export const isValidSpanishID = (id) => {
  if (!isSpain() || !id) return true; // Si no es España, no se valida

  const cleanedId = id.trim().toUpperCase();

  // Letras de control para NIF de persona física/NIE
  const letters = "TRWAGMYFPDXBNJZSQVHLCKE";

  // Regex para distinguir
  const personRegex = /^[XYZ0-9][0-9]{7}[A-Z]$/;              // NIF/NIE personas físicas
  const companyRegex = /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/; // NIF empresas/personas jurídicas

  let letterPart = cleanedId.slice(-1);

  // === CASO 1: Personas físicas (DNI o NIE) ===
  if (personRegex.test(cleanedId)) {
    let numbersPart;

    if (cleanedId.startsWith('X') || cleanedId.startsWith('Y') || cleanedId.startsWith('Z')) {
      // NIE
      const niePrefixNum = cleanedId.startsWith('X') ? 0 : cleanedId.startsWith('Y') ? 1 : 2;
      numbersPart = niePrefixNum + cleanedId.substring(1, cleanedId.length - 1);
    } else {
      // NIF persona física
      numbersPart = cleanedId.substring(0, cleanedId.length - 1);
    }

    const expectedLetter = letters[parseInt(numbersPart, 10) % 23];
    const letterOK = (letterPart === expectedLetter);

    FxLog.infox('FxRegion.isValidSpanishID', '...NIF/NIE persona física:', cleanedId + '->' + letterOK);
    return letterOK;
  }

  // === CASO 2: Personas jurídicas (empresas, asociaciones, etc.) ===
  if (companyRegex.test(cleanedId)) {
    const numbers = cleanedId.substring(1, 8);
    const controlChar = cleanedId.substring(8, 9);
    const type = cleanedId.charAt(0);

    let sum = 0;
    for (let i = 0; i < numbers.length; i++) {
      let n = parseInt(numbers[i], 10);
      if ((i + 1) % 2 === 0) {
        // posición par → se suma directamente
        sum += n;
      } else {
        // posición impar → multiplicar por 2 y sumar dígitos
        let dbl = n * 2;
        sum += Math.floor(dbl / 10) + (dbl % 10);
      }
    }

    const controlNum = (10 - (sum % 10)) % 10;
    const controlLetter = "JABCDEFGHI"[controlNum];

    // Según la letra inicial, debe ser número, letra o ambos
    let isValid = false;
    if ("ABEH".includes(type)) {
      isValid = controlChar === String(controlNum);
    } else if ("KPQS".includes(type)) {
      isValid = controlChar === controlLetter;
    } else {
      isValid = controlChar === String(controlNum) || controlChar === controlLetter;
    }

    FxLog.infox('FxRegion.isValidSpanishID', '...NIF empresa:', cleanedId + '->' + isValid);
    return isValid;
  }

  FxLog.infox('FxRegion.isValidSpanishID', '...Formato no reconocido:', cleanedId + '->false');
  return false;
};

export const verifactuPrecheck = async (totalInvoices) => {
  if (getStoreValue('StoreSession', 'txERec')!=='VF') return "OK";

  let record = {};
  record['strTotalInvoices'] = totalInvoices.toString();
  record['strNombreRazon'] = getStoreValue('StoreSession', 'txCompany');
  record['strNif'] = getStoreValue('StoreSession', 'txEin');
  return Promise.all([FxFetch.doJsonX(`verifactu/precheck`, record)]).then((result) => {
    if (result[0]) {
      return result[0].theValue;
    } else {
      return 'rv_error';
    }
  });
}
